import {collection, doc, getFirestore} from 'firebase/firestore';
import {firebaseApp} from './firebase';

export const db = getFirestore(firebaseApp);

// Flat top-level collection — playlists are addressable by ID alone so a public
// playlist can be opened via its share link without knowing the owner's uid.
export const playlistsCol = collection(db, 'playlists');
export const playlistDoc = (playlistId: string) => doc(playlistsCol, playlistId);

// Per-user data: favorites, liked songs, recently played. Single doc per uid —
// small enough to read/write wholesale, simpler than splitting into subcollections.
export const usersCol = collection(db, 'users');
export const userDoc = (uid: string) => doc(usersCol, uid);
